export enum Flags {
  DischargeQuestions = 'discharge_questions',
  AltcsPending = 'altcs_pending',
  ComparisonForAiSummary = 'comparison_for_ai_summary',
  InboundReferrals = 'inbound_referrals',
  InsightsInboundReferrals = 'insights_inbound_referrals',
}
